import { ParticipantLabel } from '@seen/core/models/participantLabel'
import { cn } from '@seen/ui'
import type { ReactNode } from 'react'
import { LabelColor } from '#src/components/LabelColor.tsx'
import { useRead } from '#src/hooks/useRead.ts'

export function ParticipantLabelCircles({
  labelReferenceStrings,
}: {
  labelReferenceStrings: string[]
}): ReactNode {
  return (
    <div className={cn('space-x-[-0.28125rem] flex rtl:space-x-reverse')}>
      {labelReferenceStrings.slice(0, 3).map((labelReferenceString) => (
        <div
          key={labelReferenceString}
          className="relative rounded-full border border-white bg-white"
        >
          <ParticipantLabelCircle labelReferenceString={labelReferenceString} />
        </div>
      ))}
    </div>
  )
}

function ParticipantLabelCircle({
  labelReferenceString,
}: {
  labelReferenceString: string
}): ReactNode {
  const { data: label } = useRead(ParticipantLabel, labelReferenceString)
  return <LabelColor color={label?.color} />
}
